/* ==========================================================================
   Doll Faced Rebellion — theme.js (lookbook v10)
   - Shopify AJAX Cart API: /cart.js, /cart/add.js, /cart/change.js
   - Bag drawer, mobile menu, ticker-safe UI
   - Rogue Society dossier swap, shop filter chips
   - Roxy React (interactive pills + per-product attributed lines)
   No floating Roxy widget. No in-memory cart. Checkout → Shopify /checkout.
   ========================================================================== */
(function () {
  "use strict";

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || "USD";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: cur }).format(cents / 100);
    } catch (e) { return "$" + (cents / 100).toFixed(2); }
  }

  /* ---------------- drawer + menu ---------------- */
  var cart = $("#dCart"), scrim = $("#dScrim"), menu = $("#dMenu");
  var lastFocus = null;

  function openCart() {
    if (!cart) { window.location.href = root + "cart"; return; }
    closeMenu();
    lastFocus = document.activeElement;
    cart.classList.add("on"); scrim.classList.add("on");
    cart.setAttribute("aria-hidden", "false"); cart.inert = false;
    var c = $("[data-cart-close]", cart); if (c) c.focus();
  }
  function closeCart() {
    if (!cart) return;
    cart.classList.remove("on"); scrim.classList.remove("on");
    cart.setAttribute("aria-hidden", "true"); cart.inert = true;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function openMenu() {
    if (!menu) return;
    menu.classList.add("on"); menu.setAttribute("aria-hidden", "false"); menu.inert = false;
    var f = $("a, button", menu); if (f) f.focus();
    $$("[data-menu-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
  }
  function closeMenu() {
    if (!menu) return;
    menu.classList.remove("on"); menu.setAttribute("aria-hidden", "true"); menu.inert = true;
    $$("[data-menu-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
  }
  window.openDrawer = openCart;
  window.closeDrawer = closeCart;

  /* ---------------- cart render ---------------- */
  function renderCart(c) {
    var count = $("#dCount"); if (count) count.textContent = c.item_count;
    var items = $("#dItems"); if (!items) return;
    if (!c.items.length) {
      items.innerHTML = '<p class="d-cart-empty"><span class="d-mk d-roxyline">Empty bag. Bold strategy.</span></p>';
    } else {
      items.innerHTML = c.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "$1$2") : "";
        var variant = it.variant_title && it.variant_title !== "Default Title"
          ? '<div class="d-var">' + esc(it.variant_title) + "</div>" : "";
        return '<div class="d-line" data-key="' + esc(it.key) + '">' +
          '<div class="d-sw">' + (img ? '<img src="' + esc(img) + (img.indexOf("?") > -1 ? "&" : "?") + 'width=120" alt="" loading="lazy">' : "") + "</div>" +
          "<div><a class=\"d-nm\" href=\"" + esc(it.url) + '">' + esc(it.product_title) + "</a>" + variant +
          '<div class="d-qty"><button type="button" data-qty="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity +
          '</span><button type="button" data-qty="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="d-rm" data-rm>Remove</button></div>' +
          '<div class="d-lab" style="color:var(--white)">' + money(it.final_line_price) + "</div></div>";
      }).join("");
    }
    var sub = $("#dSubtotal"); if (sub) sub.textContent = money(c.items_subtotal_price);
    var tot = $("#dTotal"); if (tot) tot.textContent = money(c.total_price);
    var co = $("#dCheckout"); if (co) co.disabled = c.item_count === 0;
    renderUpsell(c);
  }
  var recsFor = null;
  function renderUpsell(c) {
    var box = $("#dUpsell"); if (!box) return;
    box.hidden = c.item_count === 0;
    var recs = $("#dRecs"), list = $("#dRecsList");
    if (!recs || !list || box.getAttribute("data-recs") !== "true" || !c.items.length) { if (recs) recs.hidden = true; return; }
    var pid = c.items[0].product_id;
    var inCart = c.items.map(function (it) { return it.product_id; });
    var key = pid + ":" + inCart.join(",");
    if (recsFor === key) return;
    recsFor = key;
    var show = function (products) {
      var picks = (products || []).filter(function (p) { return inCart.indexOf(p.id) === -1 && p.available; }).slice(0, 2);
      if (!picks.length) { recs.hidden = true; return; }
      list.innerHTML = picks.map(function (p) {
        var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf("?") > -1 ? "&" : "?") + "width=120" : "";
        return '<a class="d-rec" href="' + esc(p.url) + '">' +
          (img ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="60" height="60">' : '<span class="d-rec-ph" aria-hidden="true"></span>') +
          '<span class="d-rec-t">' + esc(p.title) + '<span class="d-rec-p">' + money(p.price) + "</span></span></a>";
      }).join("");
      recs.hidden = false;
    };
    var get = function (intent) {
      return fetch(root + "recommendations/products.json?product_id=" + pid + "&limit=4&intent=" + intent)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (j) { return j.products || []; });
    };
    get("complementary").then(function (p) { return p.length ? p : get("related"); })
      .then(show).catch(function () { recs.hidden = true; });
  }
  function fetchCart() {
    return fetch(root + "cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); }).then(function (c) { renderCart(c); return c; });
  }
  function addToCart(id, qty) {
    return fetch(root + "cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function (j) { return fetchCart().then(function () { openCart(); return j; }); });
  }
  function changeLine(key, qty) {
    return fetch(root + "cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  window.dfrAddToCart = addToCart;

  /* ---------------- Roxy React ---------------- */
  var rsay = $("#dRsay"), rwho = $("#dRwho");
  function setReact(text, who) {
    if (!rsay) return;
    rsay.textContent = text;
    if (rwho) rwho.textContent = who ? "— " + who : "Roxy — No. 27";
  }
  function closeBubbles() { $$("[data-rbubble].on").forEach(function (b) { b.classList.remove("on"); }); }

  /* ---------------- clicks ---------------- */
  document.addEventListener("click", function (e) {
    var t = e.target;
    var el;

    if ((el = t.closest("[data-add-to-cart]"))) {
      e.preventDefault();
      if (el.disabled) return;
      var card = el.closest(".d-prod, form, .product-info");
      var sel = card && card.querySelector("[data-variant-select]");
      var id = sel ? sel.value : el.getAttribute("data-variant-id");
      var qi = card && card.querySelector("[data-qty-input]");
      var qty = qi ? parseInt(qi.value, 10) || 1 : 1;
      if (!id) return;
      var label = el.textContent;
      el.disabled = true; el.textContent = "Adding…";
      addToCart(id, qty).catch(function (err) {
        el.textContent = (err && err.description) ? "Unavailable" : "Try again";
        setTimeout(function () { el.textContent = label; }, 2200);
        label = null;
      }).then(function () {
        el.disabled = false;
        if (label) el.textContent = label;
      });
      return;
    }
    if ((el = t.closest("[data-cart-open]"))) { e.preventDefault(); openCart(); return; }
    if (t.closest("[data-cart-close]")) { e.preventDefault(); closeCart(); return; }
    if (t.closest("[data-menu-open]")) { e.preventDefault(); openMenu(); return; }
    if (t.closest("[data-menu-close]")) { e.preventDefault(); closeMenu(); return; }
    if (menu && menu.classList.contains("on") && t.closest("#dMenu a")) { closeMenu(); }

    if ((el = t.closest("[data-rm]"))) {
      changeLine(el.closest(".d-line").getAttribute("data-key"), 0); return;
    }
    if ((el = t.closest("[data-qty]"))) {
      var line = el.closest(".d-line");
      var cur = parseInt($("span", el.parentNode).textContent, 10) || 1;
      changeLine(line.getAttribute("data-key"), Math.max(0, cur + parseInt(el.getAttribute("data-qty"), 10)));
      return;
    }
    if ((el = t.closest("[data-checkout]"))) {
      if (el.disabled) return;
      window.location.href = root + "checkout"; return;
    }

    /* per-product Roxy React */
    if ((el = t.closest("[data-react]"))) {
      e.preventDefault();
      var q = el.getAttribute("data-quote"), who = el.getAttribute("data-who");
      var holder = el.closest(".d-prod");
      closeBubbles();
      if (holder) {
        var b = $("[data-rbubble]", holder); if (b) b.classList.add("on");
      } else {
        var tgt = document.getElementById(el.getAttribute("aria-controls") || "");
        if (tgt) { tgt.hidden = !tgt.hidden; el.setAttribute("aria-expanded", String(!tgt.hidden)); }
      }
      setReact("“" + q + "”", who);
      return;
    }
    if (t.closest("[data-rclose]")) { closeBubbles(); return; }

    /* Roxy React pills */
    if ((el = t.closest("[data-ask]"))) {
      $$("[data-ask]").forEach(function (p) { p.classList.toggle("on", p === el); p.setAttribute("aria-pressed", p === el ? "true" : "false"); });
      setReact(el.getAttribute("data-ask"), null);
      return;
    }

    /* roster dossier */
    if ((el = t.closest("[data-pick]"))) {
      var idp = el.getAttribute("data-pick");
      var sec = el.closest("section") || document;
      $$("[data-pick]", sec).forEach(function (c) {
        var on = c === el; c.classList.toggle("sel", on); c.setAttribute("aria-selected", on ? "true" : "false");
      });
      $$("[data-dossier]", sec).forEach(function (d) { d.hidden = d.getAttribute("data-dossier") !== idp; });
      return;
    }

    /* shop filters */
    if ((el = t.closest("[data-filter]"))) {
      var name = el.getAttribute("data-filter");
      var wrap = el.closest("section") || document;
      $$("[data-filter]", wrap).forEach(function (b) {
        var on = b === el; b.classList.toggle("on", on); b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      var key = "|" + name.toLowerCase() + "|", shown = 0;
      $$(".d-prod", wrap).forEach(function (p) {
        var ok = name === "All" || (p.getAttribute("data-groups") || "").toLowerCase().indexOf(key) > -1;
        p.hidden = !ok; if (ok) shown++;
      });
      var empty = $("[data-filter-empty]", wrap); if (empty) empty.hidden = shown > 0;
      closeBubbles();
      return;
    }
  });

  /* deep links like /#react from other pages keep working; lookbook plates
     that point at #shop with a data-filter-to can pre-select a chip */
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") { closeCart(); closeMenu(); closeBubbles(); }
  });

  document.addEventListener("DOMContentLoaded", fetchCart);

  /* ---------------- product page: variant picker (unchanged plumbing) ---------------- */
  $$("[data-product-form]").forEach(function (form) {
    var variants = [];
    try { variants = JSON.parse(form.getAttribute("data-variants")); } catch (err) { variants = []; }
    var optionCount = parseInt(form.getAttribute("data-option-count"), 10) || 1;
    var selected = new Array(optionCount).fill(null);
    var addBtn = form.querySelector("[data-add-to-cart]");
    var info = form.closest(".product-info") || document;
    var priceEl = info.querySelector("[data-variant-price]");
    var stockEl = form.querySelector("[data-stock-msg]");
    var mediaImg = document.querySelector("[data-product-media-img]");

    form.querySelectorAll(".variant-swatch.selected").forEach(function (btn) {
      selected[parseInt(btn.getAttribute("data-option-index"), 10)] = btn.getAttribute("data-value");
    });
    function findVariant() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === null || selected[i] === opt; });
      });
    }
    function update() {
      var v = findVariant();
      if (!v) { if (addBtn) { addBtn.disabled = true; addBtn.textContent = "Unavailable"; } return; }
      if (addBtn) {
        addBtn.setAttribute("data-variant-id", v.id);
        addBtn.disabled = !v.available;
        addBtn.textContent = v.available ? "Add to Bag" : "Sold Out";
      }
      if (priceEl) priceEl.textContent = money(v.price);
      var sp = document.querySelector("[data-variant-price-sticky]"); if (sp) sp.textContent = money(v.price);
      if (mediaImg && v.featured_image && v.featured_image.src) {
        mediaImg.src = v.featured_image.src + (v.featured_image.src.indexOf("?") > -1 ? "&" : "?") + "width=900";
      }
      if (stockEl) {
        if (!v.available) { stockEl.textContent = stockEl.getAttribute("data-msg-out") || "Not available in this option"; stockEl.className = "stock-msg out"; }
        else { stockEl.textContent = stockEl.getAttribute("data-msg-in") || "Made to order, printed just for you"; stockEl.className = "stock-msg"; }
      }
    }
    form.querySelectorAll(".variant-swatch").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var idx = parseInt(btn.getAttribute("data-option-index"), 10);
        form.querySelectorAll('.variant-swatch[data-option-index="' + idx + '"]').forEach(function (b) { b.classList.remove("selected"); b.setAttribute("aria-pressed", "false"); });
        btn.classList.add("selected"); btn.setAttribute("aria-pressed", "true");
        selected[idx] = btn.getAttribute("data-value");
        update();
      });
    });
    var input = form.querySelector("[data-qty-input]");
    form.querySelectorAll("[data-qty-plus]").forEach(function (b) { b.addEventListener("click", function () { if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) + 1); }); });
    form.querySelectorAll("[data-qty-minus]").forEach(function (b) { b.addEventListener("click", function () { if (input) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); }); });
    update();
  });
})();

/* Size guide dialog (product page) */
(function () {
  document.querySelectorAll("[data-size-open]").forEach(function (btn) {
    var dlg = document.getElementById(btn.getAttribute("aria-controls"));
    if (!dlg || typeof dlg.showModal !== "function") return;
    btn.addEventListener("click", function () { dlg.showModal(); });
    dlg.addEventListener("click", function (e) { if (e.target === dlg || e.target.hasAttribute("data-size-close")) dlg.close(); });
  });
})();

/* 10% offer tab: dismiss and remember */
(function () {
  var w = document.querySelector("[data-tenoff]");
  if (!w) return;
  var x = w.querySelector("[data-tenoff-close]");
  if (x) x.addEventListener("click", function () {
    w.hidden = true;
    try { localStorage.setItem("dfrTenoff", "1"); } catch (e) {}
  });
})();

/* Sticky Add to Bag on phones: shows once the main button scrolls away */
(function () {
  var bar = document.querySelector("[data-sticky-atc]");
  var main = document.querySelector("[data-add-to-cart]");
  if (!bar || !main || !("IntersectionObserver" in window)) return;
  var sb = bar.querySelector("[data-sticky-add]");
  new IntersectionObserver(function (es) {
    var gone = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
    bar.hidden = !gone;
  }).observe(main);
  if (sb) sb.addEventListener("click", function () { main.click(); });
})();

